import type { JSX } from "react";
import { Route, Routes } from "react-router-dom";
import AllAnswers from "./allAnswers/AllAnswers";
import MyAnswer from "./MyAnswer";
import type { ISubmittedTask } from "./query";

interface IProps {
    task: ISubmittedTask;
}

function SubmittedTaskRoutes({ task }: IProps): JSX.Element {
    return (
        <Routes>
            {task.showSharedAnswers && <Route path=":taskId/all-answers" element={<AllAnswers task={task} />} />}
            <Route path=":taskId/*" element={<MyAnswer task={task} />} />
        </Routes>
    );
}

export default SubmittedTaskRoutes;
